import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const DistributorRoute: React.FC = () => {
  const { user } = useUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const role = (user.Role || user.role || '').toLowerCase();
  const isDistributor = role === 'distributor' || role === 'distributor admin'
    || role === 'distributor rep' || (role === 'rep' && !!user.distributorID);

  if (!isDistributor) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export const DistributorWriteRoute: React.FC = () => {
  const { user } = useUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const role = (user.Role || user.role || '').toLowerCase();
  const isDistributor = role === 'distributor' || role === 'distributor admin'
    || role === 'distributor rep' || (role === 'rep' && !!user.distributorID);

  if (!isDistributor) {
    return <Navigate to="/login" replace />;
  }

  const isViewOnly = role === 'distributor rep' || (role === 'rep' && !!user.distributorID);
  if (isViewOnly) {
    return <Navigate to="/distributor/submissions" replace />;
  }

  return <Outlet />;
};

export default DistributorRoute;
